// React
import { useEffect, useState } from "react";

// Third-Party
import { LoadingButton } from "@mui/lab";
import { Button, Stack, TextField } from "@mui/material";

// Internal
import { DialogComponent } from "@components/Dialog";
import {
  renameModalActionsStyle,
  renameModalTextFieldStyle,
} from "../../styles/askDostStyles";

// Types
import { TTranslateFn } from "../../types";

interface IAskDostRenameModalProps {
  open: boolean;
  initialTitle: string;
  isRenaming: boolean;
  translate: TTranslateFn;
  onCancel: () => void;
  onSave: (title: string) => void;
}

export const AskDostRenameModal = ({
  open,
  initialTitle,
  isRenaming,
  translate,
  onCancel,
  onSave,
}: IAskDostRenameModalProps) => {
  const [title, setTitle] = useState(initialTitle);

  useEffect(() => {
    if (open) setTitle(initialTitle);
  }, [open, initialTitle]);

  const trimmedTitle = title.trim();
  const isSaveDisabled =
    !trimmedTitle || trimmedTitle === initialTitle.trim() || isRenaming;

  const handleSave = () => {
    if (isSaveDisabled) return;
    onSave(trimmedTitle);
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key !== "Enter") return;
    event.preventDefault();
    handleSave();
  };

  return (
    <DialogComponent
      isShowModal={open}
      showModalMethod={onCancel}
      dialogTitle={translate("rename_conversation")}
      maxWidth="xs"
      fullWidth
      dialogContent={
        <TextField
          autoFocus
          fullWidth
          size="small"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          onKeyDown={handleKeyDown}
          sx={renameModalTextFieldStyle}
        />
      }
      dialogActions={
        <Stack direction="row" spacing={1} sx={renameModalActionsStyle}>
          <Button onClick={onCancel} variant="outlined" size="small">
            {translate("cancel")}
          </Button>
          <LoadingButton
            onClick={handleSave}
            loading={isRenaming}
            disabled={isSaveDisabled}
            variant="contained"
            size="small"
          >
            {translate("save")}
          </LoadingButton>
        </Stack>
      }
    />
  );
};
